import { useQuery } from 'react-query';
import { getDataByLeagueId } from '../models/score/api';

export const useScoreByLeagueId = (leagueId) => {
  return useQuery(
    ['useScoreByLeagueId', leagueId],
    async () => getDataByLeagueId(leagueId).then((result) => result.data),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: 1,
      enabled: !!leagueId,
    }
  );
};
